import { Histogram } from "@/features/survey-results/survey-results-types";

interface SimpleBarChartProps {
  histogram?: Histogram;
}

const SimpleBarChart: React.FC<SimpleBarChartProps> = ({ histogram }) => {
  if (!histogram || histogram.length == 0) {
    return <div className="text-slate-400">No data</div>;
  }
  const data = formatData(histogram);
  const maxValue = data[0].value; // Data is sorted

  // Hack because we have not clarified what we want regarding counts vs percentages so to make
  // Sure to display easily I make sure numbers don't go over 100
  // But I don't normalize if all numbers are already under 100 since they may be %
  let normalizingFactor = 1;
  if (maxValue > 100) {
    normalizingFactor = 100 / maxValue;
  }

  return (
    <div>
      {data.map(({ choice, value }) => (
        <div key={choice} className="mb-4">
          {choice}: {value}
          <div className="bg-slate-400">
            <div
              className="bg-[#38bdf9] h-6"
              style={{ width: `${value * normalizingFactor}%`, minWidth: 1 }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

function formatData(histogram: Histogram): { choice: string; value: number }[] {
  return histogram
    .map((x) => ({
      choice: x.choice,
      value: x.count,
    }))
    .sort((a, b) => b.value - a.value);
}

export default SimpleBarChart;
